import type { Configuration } from '~/types/configurator'

export default function useConfigurationLink(
  configuration: Ref<Configuration | null>,
  currentValues: ComputedRef<Configuration['values']>,
  count: Ref<number>,
  sharedConfigurationSlug: Ref<string | null>
) {
  const configurationLink = ref('')
  const configurationSlug = ref('')
  const configurationLinkLoading = ref(true)
  const configurationLinkDirty = ref(true)

  const configuratorRepo = createConfiguratorRepository()

  if (import.meta.client && sharedConfigurationSlug.value) {
    configurationLink.value =
      window.location.origin +
      window.location.pathname +
      '?config=' +
      sharedConfigurationSlug.value
    configurationLinkDirty.value = false
    configurationLinkLoading.value = false
  }

  watch(
    () => [configuration.value, currentValues.value, count.value],
    () => {
      configurationLinkDirty.value = true
    },
    { deep: true }
  )

  async function getConfigurationLink() {
    if (!window || !configuration.value) return ''

    configurationLinkLoading.value = true
    try {
      const { slug } = await configuratorRepo.getUserConfigurationSlug({
        productNid: configuration.value.productNid,
        values: currentValues.value,
        count: count.value,
      })
      configurationLink.value =
        window.location.origin + window.location.pathname + '?config=' + slug
      configurationSlug.value = slug
      configurationLinkDirty.value = false
    } catch {
      configurationLink.value = ''
    }

    configurationLinkLoading.value = false
  }

  return {
    configurationLink: readonly(configurationLink),
    configurationSlug: readonly(configurationSlug),
    configurationLinkLoading: readonly(configurationLinkLoading),
    configurationLinkDirty: readonly(configurationLinkDirty),
    getConfigurationLink,
  }
}
